import React from 'react'

const Plus = () => {
    return (  
        <svg width="27" height="27" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="#000" strokeWidth="3" d="M14.5 0v27M27 14.5H0"/></svg>
    );
}
 
export default Plus;